import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { convertSlote, roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByTimeSlot = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [paginationModel] = useState(paginationLimit);
  const [dataSource, setDataSource] = useState([]);

  const getAllReportsByTimeSlot = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };

      let response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_TIME_SLOT,
        "get",
        {},
        { params: params },
        true
      );

      let apiResponse = response?.data;

      if (apiResponse?.status === "SUCCESS") {
        if (Array.isArray(apiResponse?.data)) {
          let resultData = apiResponse.data
            .filter((item) => {
              return (
                item.timeSlot && 
                item.timeSlot !== "unknown" && 
                item.timeSlot !== "Unknown" &&
                item.timeSlot.trim() !== "" &&
                item.timeSlot.includes("-")
              );
            })
            .map((item, index) => {
              let timeSlot = "Unknown";

              if (item.timeSlot && item.timeSlot.includes("-")) {
                let [openRaw, closeRaw] = item.timeSlot.split("-");

                let open = openRaw ? openRaw.trim().replace(/:00$/, "") : "--";
                let close = closeRaw ? closeRaw.trim().replace(/:00$/, "") : "--";

                if (open !== "--" && close !== "--" && open !== "" && close !== "") {
                  const formattedOpen = convertSlote(open);
                  const formattedClose = convertSlote(close);
                  timeSlot = `${formattedOpen} - ${formattedClose}`;
                } else {
                  return null;
                }
              } else {
                return null;
              }

              return {
                key: index,
                timeSlotId: item.timeSlotId,
                timeSlot: timeSlot,
                totalCount: item.totalCount,
                totalAmount: roundToDecimal(item.totalAmount, 2),
              };
            })
            .filter(Boolean);
          setDataSource(resultData);
        }
      } else {
        toast.error(apiResponse?.message);
      }

    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByTimeSlot();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
      title: "Time Slot",
      dataIndex: "timeSlot",
      key: "timeSlot",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    {
      title: "Total Orders",
      dataIndex: "totalCount",
      key: "totalCount",
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/get-time-slot/${record?.timeSlotId}`, {
              state: { inputData: inputData, tabIndex: tabIndex },
            });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text}
        </Typography>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />
    </>
  );
};

export default SalesByTimeSlot;